import React, { Fragment, useEffect, useState } from 'react'
import EmployeeTimesheetSc from './AdminTimesheet.sc'
import { useAuthContext } from '../../hooks'
import { getUserPerformanceAsPeopleLead } from '../../api/peopleLeadPerformance/getUserGoalAsPl'
import { useNavigate } from 'react-router-dom'
const AdminTimeSheet = () => {
  const [getMemberPerformance, setGetMemberPerformance] = useState<any[]>([])
  const auth = useAuthContext()
  const fetchOrguserProjects = async () => {
    await getUserPerformanceAsPeopleLead(
      auth?.userInfo?.orgs[0]?.id,
      (auth?.userInfo?.orgs_user_id[0]).toString(),
    )
      .then((e) => {
        console.log(e, 'hello then')
        setGetMemberPerformance(e)
      })
      .catch((e) => console.log(e))
  }
  useEffect(() => {
    fetchOrguserProjects()
  }, [])
  const navigate = useNavigate()

  return (
    <EmployeeTimesheetSc>
      <div>AdminTimeSheet</div>
      <div className="employee-container">
        {getMemberPerformance.length > 0 ? (
          getMemberPerformance?.map((data: any, idx: any) => {
            return (
              <Fragment key={idx}>
                <div className="employee-list-containers-mag">
                  <div className="profile-list-mag">
                    <div className="employee-image"></div>
                    <div className="employee-name ">{data.Name}</div>
                  </div>
                  <div className="employee-list">{data.Evaluation}</div>
                  <div
                    className="performance-status"
                    onClick={() => navigate(data.org_user_id)}
                  >
                    <div className="project-lead-approval-status">
                      View Details
                    </div>
                  </div>
                </div>
              </Fragment>
            )
          })
        ) : (
          <div className="alert-messages">
            Only people lead can access this page
          </div>
        )}
      </div>
    </EmployeeTimesheetSc>
  )
}

export default AdminTimeSheet
